"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asOrdinalNumber = void 0;

var _number = require("../type-checks/number");

var _string = require("../type-checks/string");

var asOrdinalNumber = function asOrdinalNumber(input) {
  var initialValue = null,
      remainderOnes = null,
      remainderTens = null,
      returnElem = input;

  if ((0, _number.isNumber)(input)) {
    initialValue = input;
  } else if ((0, _string.isStringOfLength)(input)) {
    initialValue = parseInt(input, 10);
  }

  if ((0, _number.isNumber)(initialValue)) {
    returnElem = initialValue.toString();
    remainderOnes = initialValue % 10;
    remainderTens = initialValue % 100;

    if (remainderOnes === 1 && remainderTens !== 11) {
      returnElem += "st";
    } else if (remainderOnes === 2 && remainderTens !== 12) {
      returnElem += "nd";
    } else if (remainderOnes === 3 && remainderTens !== 13) {
      returnElem += "rd";
    } else {
      returnElem += "th";
    }
  }

  return returnElem;
};

exports.asOrdinalNumber = asOrdinalNumber;